let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '优惠券配置ID',
        props: 'couponNo',
        minWidth: 220,
    },
    {
        label: '优惠券名称',
        props: 'couponName',
        minWidth: 200,
    },
    {
        label: '第三方活动ID',
        props: 'couponExchangeNo',
        minWidth: 200,
    },
    {
        label: '优惠券类型',
        props: 'couponTypeName',
        minWidth: 180,
    },
    {
        label: '卡券归属',
        props: 'couponBelongName',
        minWidth: 150,
    },
    {
        label: '发放平台',
        props: 'provideChannelName',
        minWidth: 180,
    },
    {
        label: '优惠券配置状态',
        props: 'couponStatusName',
        minWidth: 200,
    },
    {
        label: '优惠券数量',
        props: 'couponCount',
        minWidth: 200,
    },
    {
        label: '已发放数量',
        props: 'provideCount',
        minWidth: 90,
    },
    {
        label: '券值/元',
        props: 'prizeAmount',
        minWidth: 130,
    },
    {
        label: '使用门槛',
        props: 'couponReductionThreshold',
        minWidth: 130,
    },
    {
        label: '积分兑换数',
        props: 'exchangePoints',
        minWidth: 130,
    },
    {
        label: '兑换开始时间',
        props: 'startExchangeTime',
        minWidth: 130,
    },
    {
        label: '兑换结束时间',
        props: 'endExchangeTime',
        minWidth: 200,
    },
    {
        label: '可用期限/天',
        props: 'validityDay',
        minWidth: 200,
    },
    {
        label: '备注',
        props: 'remark',
        minWidth: 200,
    },
    {
        label: '创建人',
        props: 'createdByName',
        minWidth: 200,
    },
    {
        label: '创建时间',
        props: 'createdWhen',
        minWidth: 200,
    },
    {
        label: '更新人',
        props: 'lastModifiedByName',
        minWidth: 200,
    },
    {
        label: '更新时间',
        props: 'lastModifiedWhen',
        minWidth: 200,
    },
];
pageConfig.logListColumns = [
    {
        label: '更新人',
        props: 'couponName',
        minWidth: 220,
    },
    {
        label: '更新时间',
        props: 'couponNo',
        minWidth: 200,
    },
    {
        label: '更新操作',
        props: 'couponExchangeNo',
        minWidth: 200,
    },
    {
        label: '更新操作',
        props: 'couponTypeName',
        minWidth: 180,
    },
   
];

// // 面包屑
pageConfig.listBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '优惠券管理'
    },
    {
        type: 'title',
        name: '优惠券配置'
    }
];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: true,
    showIndex: false,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}


// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'id',
    editRouter: 'pileDetail',
};

// 路由
pageConfig.listRouter = 'couponAllocation';

pageConfig.reportDetailRouter = 'pileReportDetail';

pageConfig.chargeDetailRouter = 'pileChargeDetail';

pageConfig.repairListDetail = 'repairListDetail';

pageConfig.faultDetail = 'faultDetail';

//维修新增路由
pageConfig.repairAddRouter = 'repairAddDetail';

//维修路由
pageConfig.repairRouter = 'repairDetail';

// 关联账号
pageConfig.relationNum = 'relationNum';

// 详情的面包屑
pageConfig.detailBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '优惠券管理',
    },
    {
        type: 'router',
        name: '优惠券配置',
        router: 'couponAllocation'
    },
    {
        type: 'title',
        name: '优惠券详情'
    }
];
// 详情的面包屑
pageConfig.logBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '优惠券管理',
    },
    {
        type: 'router',
        name: '优惠券配置',
        router: 'couponAllocation'
    },
    {
        type: 'title',
        name: '更新记录'
    }
];


pageConfig.formRules = {
    couponName: [{ required: true, message: '请输入优惠券名称', trigger: 'blur' }],
    couponBelong: [{ required: true, message: '请选择卡券归属', trigger: 'change' }],
    provideChannel: [{ required: true, message: '请选择发放平台', trigger: 'change' }],
    couponType: [{ required: true, message: '请选择优惠券品类', trigger: 'change' }],
    couponExchangeNo: [{ required: true, message: '请输入第三方活动ID', trigger: 'blur' }],
    couponCount: [{ required: true, message: '请输入优惠券数量', trigger: 'blur' }],
    prizeAmount: [{ required: true, message: '请输入金额', trigger: 'blur' }],
    couponUseType: [{ required: true, message: '请选择门槛', trigger: 'change' }],
    startExchangeTime: [{ required: true, message: '请选择开始兑换时间', trigger: 'change' }],
    validityDay: [{ required: true, message: '请输入卡券有效期', trigger: 'blur' }],
    couponIllustrate: [{ required: true, message: '请输入优惠券说明', trigger: 'blur' }],
    couponRule: [{ required: true, message: '请输入优惠券规则', trigger: 'blur' }],
    // endExchangeTime: [{ required: true, message: '请选择结束兑换时间', trigger: 'change' }],
    endTimeType: [{ required: true, message: '请选择结束兑换时间', trigger: 'change' }],
};



export default pageConfig;
